import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import DataTable from 'react-data-table-component';

import programStatuses from 'data/program_statuses';

export default function Details({ template, programsToClose, setProgramsToClose }) {
  const programStatus = (value) => programStatuses.find((status) => status.value === value).label;

  const columns = [
    {
      name: 'Member',
      selector: (row) => row.member,
      sortable: true,
    },
    {
      name: 'Coach',
      selector: (row) => row.coach,
      sortable: true,
    },
    {
      name: 'Status',
      selector: (row) => row.status,
      cell: (row) => programStatus(row.status),
      sortable: true,
    },
  ];

  useEffect(() => {
    if (template) {
      setProgramsToClose(
        template.attributes.programs.filter((program) => program.status !== 'completed')
          .map((program) => program.id),
      );
    }
  }, [template]);

  return (
    <DataTable
      columns={columns}
      data={
        template ? template.attributes.programs.filter((program) => program.status !== 'completed') : []
      }
      className="datatable-style"
      noHeader
      pagination
      selectableRows
      onSelectedRowsChange={({ selectedRows }) => {
        setProgramsToClose(selectedRows.map((row) => row.id));
      }}
      selectableRowSelected={(row) => programsToClose.includes(row.id)}
    />
  );
}

Details.propTypes = {
  template: PropTypes.object,
  programsToClose: PropTypes.arrayOf(PropTypes.number).isRequired,
  setProgramsToClose: PropTypes.func.isRequired,
};

Details.defaultProps = {
  template: null,
};
